import {
  IMediaResource,
  IProcessResourceHandler,
} from '../types';

class ResourceProcessor {
  private readonly resourceProcessor: IProcessResourceHandler;

  constructor(resourceProcessor: IProcessResourceHandler) {
    this.resourceProcessor = resourceProcessor;
  }

  call(data: IMediaResource): Promise<IMediaResource> {
    return this.resourceProcessor(data);
  }
}

export default ResourceProcessor;
